import CrudTable from "../../components/CrudTable";
import { fmtTL, fmtDate } from "../../lib/format";

const nameValidate = (v, f, items, editId) => {
  if (!String(v || "").trim()) return "Tanım zorunludur";
  if (items.some((i) => i.id !== editId && (i.name || "").trim().toLocaleLowerCase("tr") === String(v).trim().toLocaleLowerCase("tr"))) return "Bu tanım zaten kayıtlı";
  return "";
};
const amountValidate = (v) => {
  const n = parseFloat(String(v).replace(",", "."));
  return isNaN(n) || n < 0 ? "Geçerli bir tutar girin" : "";
};

const WAGE_DEFAULTS = { name: "", amount: "", period: "Aylık", valid_from: "", notes: "" };
const WAGE_COLUMNS = [
  { key: "name", label: "Ücret Tanımı" },
  { key: "amount", label: "Tutar", align: "right", render: (it) => fmtTL(it.amount) },
  { key: "period", label: "Dönem" },
  { key: "valid_from", label: "Geçerlilik Başlangıcı", render: (it) => (it.valid_from ? fmtDate(it.valid_from) : "-") },
  { key: "notes", label: "Not" },
];
const WAGE_FIELDS = [
  { key: "name", label: "Ücret Tanımı (örn. Asgari Ücret Brüt, Yemek Ücreti, Yol Ücreti)", type: "text", validate: nameValidate },
  { key: "amount", label: "Tutar (TL)", type: "number", validate: amountValidate },
  { key: "period", label: "Dönem", type: "select", options: ["Aylık", "Günlük", "Saatlik"].map((v) => ({ value: v, label: v })) },
  { key: "valid_from", label: "Geçerlilik Başlangıcı", type: "date", required: false },
  { key: "notes", label: "Not", type: "text", required: false },
];

export default function WageRates() {
  return <CrudTable resource="wage-rates" title="" subtitle="" testidPrefix="wage" defaults={WAGE_DEFAULTS} columns={WAGE_COLUMNS} fields={WAGE_FIELDS} />;
}
